import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import type { RepeatableRowExtraView } from '../../../../interfaces/input.interface';

@Component({
    selector: 'app-repeatable-dose-recommendation',
    standalone: false,
    templateUrl: './repeatable-dose-recommendation.component.html',
    styleUrls: ['./repeatable-dose-recommendation.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RepeatableDoseRecommendationComponent {
    @Input() public view: RepeatableRowExtraView | null = null;
}
